import CaseFeatures from "./CaseFeatures";
import CaseStudyHero from "./CaseStudyHero";
import { ai,ats,hrms,lms } from "../../data/caseStudy";
// import CasestudyProblem from "./CasestudyProblem";
import { useParams } from "react-router-dom";

export default function CaseStudy() {
  const { name } = useParams()
  
    const current = name === ai.id ? ai : (name === ats.id ? ats : name === lms.id ? lms : hrms)
  return (
    <main>
      <CaseStudyHero images={current.images} subtitle={current.subtitle} title
        ={current.title} services={ current.services} />
      <CaseFeatures features={current.features} content={ current.content} />
      {/* <CasestudyProblem caseStudy={current.caseStudy} /> */}
      
    </main>
  )
}


